export const GET_PAYMENT_CARD_PARAMS_REQUESTED = 'GET_PAYMENT_CARD_PARAMS_REQUESTED';
export const GET_PAYMENT_CARD_PARAMS_FAILURE = 'GET_PAYMENT_CARD_PARAMS_FAILURE';
export const GET_PAYMENT_CARD_PARAMS_SUCCESS = 'GET_PAYMENT_CARD_PARAMS_SUCCESS';
export const RESET_PAYMENT_CARD_PARAMS = 'RESET_PAYMENT_CARD_PARAMS';
export const CREATE_NEW_CUSTOMER_ORDER_REQUESTED = 'CREATE_NEW_CUSTOMER_ORDER_REQUESTED';
export const CREATE_NEW_CUSTOMER_ORDER_FAILURE = 'CREATE_NEW_CUSTOMER_ORDER_FAILURE';
export const CREATE_NEW_CUSTOMER_ORDER_SUCCESS = 'CREATE_NEW_CUSTOMER_ORDER_SUCCESS';
export const GET_EXISTING_PAYMENT_CARD_DETAILS_REQUESTED = 'GET_EXISTING_PAYMENT_CARD_DETAILS_REQUESTED';
export const GET_EXISTING_PAYMENT_CARD_DETAILS_FAILURE = 'GET_EXISTING_PAYMENT_CARD_DETAILS_FAILURE';
export const GET_EXISTING_PAYMENT_CARD_DETAILS_SUCCESS = 'GET_EXISTING_PAYMENT_CARD_DETAILS_SUCCESS';
export const UPGRADE_EXISTING_ACCOUNT_REQUESTED = 'UPGRADE_EXISTING_ACCOUNT_REQUESTED';
export const UPGRADE_EXISTING_ACCOUNT_FAILURE = 'UPGRADE_EXISTING_ACCOUNT_FAILURE';
export const UPGRADE_EXISTING_ACCOUNT_SUCCESS = 'UPGRADE_EXISTING_ACCOUNT_SUCCESS';
export const SET_ZUORA_IFRAME_LOADING = 'SET_ZUORA_IFRAME_LOADING';

export const getPaymentCardParams = () => ({
  type: GET_PAYMENT_CARD_PARAMS_REQUESTED
});

export const getPaymentCardParamsFailure = error => ({
  type: GET_PAYMENT_CARD_PARAMS_FAILURE,
  error
});

export const getPaymentCardParamsSuccess = payload => ({
  type: GET_PAYMENT_CARD_PARAMS_SUCCESS,
  payload
});

export const resetPaymentCardParams = () => ({
  type: RESET_PAYMENT_CARD_PARAMS
});

export const createNewCustomerOrder = (paymentRef, licenceType, scribeId) => ({
  type: CREATE_NEW_CUSTOMER_ORDER_REQUESTED,
  paymentRef,
  licenceType,
  scribeId
});

export const createNewCustomerOrderFailure = error => ({
  type: CREATE_NEW_CUSTOMER_ORDER_FAILURE,
  error
});

export const createNewCustomerOrderSuccess = payload => ({
  type: CREATE_NEW_CUSTOMER_ORDER_SUCCESS,
  payload
});

export const getExistingPaymentMethod = currencyCode => ({
  type: GET_EXISTING_PAYMENT_CARD_DETAILS_REQUESTED,
  currencyCode
});

export const getExistingPaymentMethodFailure = error => ({
  type: GET_EXISTING_PAYMENT_CARD_DETAILS_FAILURE,
  error
});

export const getExistingPaymentMethodSuccess = payload => ({
  type: GET_EXISTING_PAYMENT_CARD_DETAILS_SUCCESS,
  payload
});

export const upgradeExistingAccount = () => ({
  type: UPGRADE_EXISTING_ACCOUNT_REQUESTED
});

export const upgradeExistingAccountFailure = error => ({
  type: UPGRADE_EXISTING_ACCOUNT_FAILURE,
  error
});

export const upgradeExistingAccountSuccess = payload => ({
  type: UPGRADE_EXISTING_ACCOUNT_SUCCESS,
  payload
});

export const setZuoraIframeLoading = payload => ({
  type: SET_ZUORA_IFRAME_LOADING,
  payload
});
